const container = "_35sc84o7g7";
const shouldHaveGroup = "_35ss3kxx37";
const stateBox = "_35ss4mn93h";
const fraction = "_35sfk4hia9";
const readonlyFractionValue = "_35sr1pu2csp";

export { container, fraction, readonlyFractionValue, shouldHaveGroup, stateBox };
import "./input.fraction.style.linaria.module.css";
//# sourceMappingURL=input.fraction.style.js.map
